import { createSelector } from 'reselect';
import { getState } from './state';

export const getDrawerSlice = createSelector([getState], slice => {
  return slice.drawer;
});

export const getDrawerActiveFilter = createSelector(getDrawerSlice, state => {
  return state?.activeFilter ?? 'all';
});
